/**
 * used with *ngFor to filter items in output
 * *ngFor should loop JSON objects containing an optional `condition` argument
 * condition is a function receiving any args provided through the Pipe
 * 
 * i.e...
 * 
    menuItems: [
        {
            label: 'Customer Info',
            condition: (arg1: any, arg2: any): boolean => {...}
        },
        ...
    ]

    <mat-grid-tile *ngFor="let item of environment.menuItems | conditionFilter:arg1:arg2">
        {{item.label}}
    </mat-grid-title>
 * 
 */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'conditionFilter',
    pure: false
})
export class ConditionFilterPipe implements PipeTransform {
    transform(
        items: { condition?: (...data: any) => boolean }[],
        ...args: any[]
    ): any {
        if (!items) return items;

        return items.filter(item => item.condition === undefined ? true : item.condition.apply(item, args));
    }
}